import React, { ReactNode } from 'react';

import Focusable from 'components/focus/Focusable';

interface FocusTrapProps {
  children?: ReactNode;
  className?: string | null;
  allowBrowserHandling?: boolean;
}

const FocusTrap = ({
  children = null,
  className = null,
  allowBrowserHandling = false,
}: FocusTrapProps) => {
  const onAction = (): boolean | string => {
    return allowBrowserHandling ? 'stopPropagation' : true;
  };

  return (
    <Focusable
      onAction={onAction}
      render={() => children}
      className={className}
    />
  );
};

export default FocusTrap;
